<template>
    <div class="popup" v-if="nPopup" @click="addCount">
        <div class="popup-box">
            <div class="popup-name">{{ nTitle }}</div>
            <div class="popup-ewm">
                <img v-if="nEwmImg != ''" :src="nEwmImg"/>
            </div>
            <div class="popup-tips">请长按二维码添加专属顾问企业微信</div>
            <div class="close">关闭</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "qrcode",
    props: {
        nPopup: {
            type: Boolean,
            default: false,
        },
        nTitle: {
            type: String,
            default: '',
        },
        nEwmImg: {
            type: String,
            // default: 'https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc0090a3b24198fbc4',
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {
        addCount() {
            // this.$emit("changeTag")
            this.$emit('update:nPopup',false)
        }
    }
};
</script>

<style lang="scss" scoped>
.popup {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);

    .popup-box {
        position: absolute;
        bottom: 112px;
        left: 50%;
        transform: translate(-50%);
        width: 686px;
        height: 824px;
        background: #FFFFFF;
        border-radius: 24px;

        .popup-name {
            margin-top: 96px;
            text-align: center;
            font-size: 48px;
            color: #333333;
        }

        .popup-ewm {
            margin-top: 64px;
            text-align: center;

            img {
                width: 440px;
                height: 440px;
            }
        }

        .popup-tips {
            text-align: center;
            margin-top: 48px;
            font-size: 32px;
            font-weight: 400;
            color: #999999;
        }

        .close {
            position: absolute;
            top: -56px;
            right: 70px;
            font-size: 28px;
            color: #FFFFFF;
        }
    }

}
</style>
